import { TableBody } from "@mui/material";
import { type Ref, forwardRef } from "react";
import type { TableBodyProps } from "react-virtuoso";
import { useTableVirtualizedSelectContext } from "../context";

export const VirtuosoTableBody = forwardRef(function VirtuosoTable(
  { children, ...props }: TableBodyProps,
  ref: Ref<HTMLTableSectionElement>
) {
  const { TableBodyProps } = useTableVirtualizedSelectContext();

  return (
    <TableBody {...props} {...TableBodyProps} ref={ref}>
      {children}
    </TableBody>
  );
});
